/**
 * @see https://umijs.org/zh-CN/plugins/plugin-access
 * */
export default function access(initialState: { currentUser?: any } | undefined) {
  const { currentUser } = initialState ?? {};
  return {
    canSuperAdmin: currentUser && currentUser.role === '0',
    canAdmin: currentUser && (currentUser.role === '1' || currentUser.role === '0'),
  };
}
